import { toCamelCase } from "./toCamelCase"

function parseFieldAnnotations(annotation: string) {
  const result: { [key: string]: boolean | string | undefined } = {}
  const regex = /@([\w-]+)(?:\((.*?)\)|\s*=\s*(".*?"|'.*?'|.*?))?(?:\s|$)/g
  let match

  while ((match = regex.exec(annotation)) !== null) {
    const key = toCamelCase(match[1].toLowerCase())
    const param1 = match[2]
    const param2 = match[3]

    if (param1 !== undefined) {
      result[key] = param1
    } else if (param2 !== undefined) {
      result[key] = param2
    } else {
      result[key] = true
    }
  }

  return result
}

function parsePlaceholder(annotations: string) {
  const parsedAnnotations = parseFieldAnnotations(annotations)
  return getPlaceholder(parsedAnnotations)
}

function getPlaceholder(annotations: ReturnType<typeof parseFieldAnnotations>) {
  if (!annotations) return undefined
  if (!annotations.placeholder) return undefined
  if (typeof annotations.placeholder !== "string") return undefined
  if (!annotations.placeholder.trim()) return undefined

  return annotations.placeholder.replace(/['"]/g, "")
}

export { parseFieldAnnotations, parsePlaceholder, getPlaceholder }
